import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getTraining() {
  const data = await axiosInstance({
    url: "/training",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

const createTraining = async (formData: any) => {
  const data = await axiosInstance({
    url: "/training",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateTraining = async (formData: any) => {
  const data = await axiosInstance({
    url: `/training/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteTraining = async (formData: any) => {
  const data = await axiosInstance({
    url: `/training/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useTraining() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.training],
    queryFn: () => getTraining(),
  });
  return data;
}

export function useCreateTraining() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createTraining(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.training]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateTraining() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateTraining(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.training]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteTraining() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteTraining(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.training]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
